import type * as React from 'react'
import { Input as InputPrimitive } from '@base-ui/react/input'

import { cn } from '@/shared/lib/cn'

function Input({ className, type, ...props }: InputPrimitive.Props & React.RefAttributes<HTMLInputElement>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        'flex w-full min-w-0 border bg-card [height:var(--control-field-height)] [border-color:var(--control-field-border)] [border-radius:var(--control-field-radius)] [padding:var(--control-field-padding)] [font-family:var(--control-font-family)] [font-size:var(--control-field-font-size)] [font-weight:var(--control-field-font-weight)] [line-height:var(--control-field-line-height)] shadow-none transition-[color,border-color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:[color:var(--control-field-placeholder)] placeholder:[opacity:var(--control-field-placeholder-opacity)] selection:bg-primary selection:text-primary-foreground disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:opacity-100',
        'hover:[border-color:var(--control-field-hover-border)] focus-visible:[border-color:var(--control-field-focus-border)] focus-visible:[box-shadow:var(--control-field-focus-shadow)]',
        // Мягкая заливка вместе с рамкой: одну рамку легко не заметить, когда полей на шаге много.
        'aria-invalid:border-destructive aria-invalid:bg-destructive-soft/40 aria-invalid:ring-2 aria-invalid:ring-destructive/20',
        className
      )}
      {...props}
    />
  )
}

export { Input }
